import React from 'react'
import Premium_image_banner from "../premium_image_banner/Premium_image_banner.js"

function premium_carousel() {
  return (
    <div>
      <Premium_image_banner/>
    </div>
  )
}

export default premium_carousel